export default __webpack_public_path__ + "img/catIcon14.85e33b2e.svg";